import React from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { useGreenEnergyContext } from "contexts/GreenEnergyContext";

const FRAME_DATA = {
  title: "Buscar melhores soluções",
  imgSrc: "/static/img/solutions/check.png",
};

const CARD_STYLE = {
  alignItems: "center",
  justifyContent: "space-evenly",
  padding: "16px 8px",
  marginBottom: "8px",
  borderRadius: "12px",
  border: "1px solid #CAC4D0",
};

export const DiagnosisCongrats = ({ history }) => {
  const { building, monthlyCost } = useGreenEnergyContext();

  return (
    <SolutionsFrame {...FRAME_DATA}>
      <BlockStandard hideDivider>
        <Typography align="center" variant="h3" sx={{ mb: 0 }}>
          Parabéns você cadastrou seu imóvel!
          <Typography align="center" variant="h3">
            Veja a diferença que a Enermatch pode fazer
          </Typography>
        </Typography>

        <Typography variant="h2" align="center">
          Soluções Enermatch
        </Typography>

        <Typography variant="caption">{building.name}</Typography>

        <TextField
          label="Custo mensal com energia"
          value={`R$ ${monthlyCost} / mês`}
          disabled
        />
      </BlockStandard>

      <BlockStandard hideDivider>
        <Grid item container sx={CARD_STYLE}>
          <img
            alt=""
            src="/static/img/solutions/green-energy.png"
            width="100px"
          />
          <Typography variant="body2">
            Contrato energia verde
            <Typography variant="caption" component="p">
              Saiba mais
            </Typography>
          </Typography>
          <Button
            variant="contained"
            fullWidth
            onClick={() => history.push("green-energy-contracts")}
          >
            Contratar
          </Button>
        </Grid>

        <Grid item container sx={CARD_STYLE}>
          <img
            alt=""
            src="/static/img/solutions/automate-ac.png"
            width="100px"
          />
          <Typography variant="body2">
            Automação de ar condicionado
            <Typography variant="caption" component="p">
              Saiba mais
            </Typography>
          </Typography>
          <Button
            variant="contained"
            fullWidth
            onClick={() => history.push("automate-ac")}
          >
            Contratar
          </Button>
        </Grid>
      </BlockStandard>
    </SolutionsFrame>
  );
};
